import { Observable } from 'rxjs';
import { fetchModelImageListAPI } from '../../api/fetch-functions/model-image';
import { IImageInfoType } from '../../types/record/image-info';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  oneIdListSetReducerGenerator,
  oneIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/one-id-list';

const fetchSignal$ = fetchIdStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchModelImageListOf = (modelId: number) => f(modelId);

/**
 * @description
 * `fetchModelImageListOf(modelId)` を実行すると
 * `modelImageListSet$` の該当idの要素を re-fetch する．
 */
const updateModelImageList$ = updateStreamGenerator(
  fetchSignal$,
  fetchModelImageListAPI
);

const modelImageListSetReducer = oneIdListSetReducerGenerator<IImageInfoType>();

/**
 * @description
 * すべての modelImageList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const modelImageListSet$ = oneIdListSetStreamGenerator(
  updateModelImageList$,
  modelImageListSetReducer
);

const g = listOfIdFnGenerator(modelImageListSet$);
export const modelImageListOf = (
  modelId: number
): Observable<ListWithPromiseState<IImageInfoType>> => {
  fetchModelImageListOf(modelId);
  return g(modelId);
};
